import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Button,
  Label,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  FormGroup,
  Form,
} from "reactstrap";
import { Link } from "react-router-dom";
import classnames from "classnames";
import Select from 'react-select';
import TableContainer from "../../../../components/Common/TableContainer";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { useFormik } from "formik";
import * as Yup from "yup";

const OnboardingProcessViewApplicant = () => {
  const [activeTab, setActiveTab] = useState("1");
  const [status, setStatus] = useState("0");
  const [data, setData] = useState([]);

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const statusOptions = [
    { value: "pending", label: "PENDING" },
    { value: "in_progress", label: "IN PROGRESS" },
    { value: "complete", label: "COMPLETE" }
  ];

  const SelectcustomStyles = {
    control: (base) => ({
      ...base,
      maxHeight: 33.1,
      minHeight: 33.1,
    }),
    indicatorsContainer: (base) => ({
      ...base,
      padding: "0",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px 8px",
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px 8px",
    }),
  };

  const applicant = {
    id: 1,
    name: "Naveen G",
    email: "naveeng@gmail.com",
    mobile: "9876543210",
    address: "123, Main Street, City",
    qualification: "B.Tech",
    vacancyCode: "ARE123",
    workedWithUs: "No",
    appliedVacancy: "Clerk Test",
    level: "2",
    wentThrough: "Initial Screening"
  };

  const formik = useFormik({
    initialValues: {
      applicantId: applicant.id,
      applicantName: applicant.name,
      allocatedTo: "",
      allocatedDate: "",
      allocatedTime: "",
      level: "",
      mode: "",
      mailTo: "",
      round: "",
    },
    validationSchema: Yup.object({
      allocatedTo: Yup.string().required("Please select a person"),
    }),
    onSubmit: (values, { resetForm }) => {
      const newEntry = { id: data.length + 1, ...values };
      setData([...data, newEntry]);
      resetForm(); // Resets form
    },
  });
  // reset handel
  const handleFormReset = () => {
    formik.resetForm();
  };

  const columns = [
    {
      Header: "S.No",
      Cell: ({ row }) => data.length - row.index,
    },
    { Header: "Levels", accessor: "level" },
    { Header: "Round", accessor: "round" },
    { Header: "Allocated To", accessor: "allocatedTo" },
    { Header: "Allocated On", accessor: "allocatedDate" },
    {
      Header: "Delete", Cell: ({ row }) => (
        <Link to="#" onClick={() => handleDelete(row.original.id)}>
          <i className="mdi mdi-trash-can font-size-18 text-danger" />
        </Link>
      )
    },
  ];

  const handleDelete = (id) => {
    setData(data.filter((item) => item.id !== id));
  };

  const levelOptions = [
    { value: "Level-1", label: "Level-1" },
    { value: "Level-2", label: "Level-2" },
    { value: "Level-3", label: "Level-3" },
    { value: "Level-4", label: "Level-4" },
    { value: "Level-5", label: "Level-5" },
  ];

  const allocatedToOptions = [
    { value: "John Doe", label: "John Doe" },
    { value: "Jane Smith", label: "Jane Smith" },
    { value: "Robert Brown", label: "Robert Brown" },
    { value: "Emily Davis", label: "Emily Davis" },
  ];

  const modeOptions = [
    { value: "Walk-in", label: "Walk-in" },
    { value: "Online", label: "Online" },
    { value: "Telecall", label: "Telecall" },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Onboarding" breadcrumbItem="View Applicant" />
          <Card>
            <CardBody>
              <Row className="mb-3">
                <Col md={6} className="mb-2">
                  <h5 className="mb-3 text-primary">Applicant Personal Details</h5>
                  <Label>Applicant ID</Label>
                  <Input type="text" value={applicant.id} disabled className="mb-2" />
                  <Label>Mobile No</Label>
                  <Input type="text" value={applicant.mobile} disabled className="mb-2" />
                  <Label>Address</Label>
                  <Input type="text" value={applicant.address} disabled className="mb-2" />
                  <Label>Qualification</Label>
                  <Input type="text" value={applicant.qualification} disabled className="mb-2" />
                  <Label>Vacancy Code</Label>
                  <Input type="text" value={applicant.vacancyCode} disabled className="mb-2" />
                  <Label>Worked With Us</Label>
                  <Input type="text" value={applicant.workedWithUs} disabled className="mb-2" />
                </Col>
                <Col md={6} className="mb-2">
                  <h5 className="mb-3 text-primary">Technical Details</h5>
                  <Label>Applicant Name</Label>
                  <Input type="text" value={applicant.name} disabled className="mb-2" />
                  <Label>Email</Label>
                  <Input type="email" value={applicant.email} disabled className="mb-2" />
                  <Label>Applied Vacancy</Label>
                  <Input type="text" value={applicant.appliedVacancy} disabled className="mb-2" />
                  <Label>Level</Label>
                  <Input type="text" value={applicant.level} disabled className="mb-2" />
                  <Label>Went Through</Label>
                  <Input type="text" value={applicant.wentThrough} disabled className="mb-2" />
                </Col>
              </Row>
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <Col>
                <Nav pills className="navtabs nav-justified d-sm-flex d-block p-0 mb-4">
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "1" })}
                      onClick={() => toggleTab("1")}>
                      Interview Review
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === "2" })}
                      onClick={() => toggleTab("2")}>
                      Document
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1">
                    <Row>
                      <Col md={4}>
                        <Label>Applicant ID</Label>
                        <Input type="text" value="1" disabled className="mb-2" />
                        </Col>

                        <Col md={4}>
                        <Label>Applicant Name</Label>
                        <Input type="text" name="applicantName" className="mb-2" value={formik.values.applicantName} readOnly />
                        </Col>

                        <Col md={4}>
                        <Label>Date</Label>
                        <Input type="date" className="mb-2" />
                        </Col>
                        
                        <Col md={4}>
                        <Label>Status</Label>
                        <Select styles={SelectcustomStyles} options={statusOptions} value={status} onChange={setStatus} classNamePrefix="hrms-select" className="hrms-select mb-2" />
                        </Col>
                        <Col md={4}>
                        <Label>Levels</Label>
                        <Input type="text" placeholder="Enter Level" className="mb-2" />
                        </Col>
                        <Col md={4}>
                        <Label>Mark</Label>
                        <Input type="text" placeholder="Enter Mark" className="mb-2" />
                        </Col>
                        <Col md={12}>
                        <Label>Comments</Label>
                        <Input type="textarea" placeholder="Enter Comments" className="mb-3" /></Col>
                        <Col md={12}>
                        <div className="d-flex justify-content-end">
                          <Button type="submit" className="btn button-save me-2"> <i className="fas fa-save me-1" /> Update </Button>
                          <Button type="reset" className="btn button-cancel"> <i className="fas fa-sync me-1" /> Clear </Button>
                        </div></Col>
                    </Row>
                  </TabPane>
                  <TabPane tabId="2">
                    <h5>Document</h5>
                    <p>Required documents and verification details.</p>
                  </TabPane>
                </TabContent>
              </Col>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default OnboardingProcessViewApplicant;